import {useEffect, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {validURL} from '~/common/fabric/CreateDesign/components/EventGifting/utils';
import {selectRegistryUrls} from '~/common/fabric/reducers/giftingOptions/selectors';
import {Button} from '~library/atoms/Button';

import './RegistryFooter.sass';

type RegistryFooterProps = {
  onRemove: () => void;
  onSave: () => void;
  localUrls: string[];
};

export const RegistryFooter = ({onRemove, onSave, localUrls}: RegistryFooterProps) => {
  const regUrls = useSelector(selectRegistryUrls, shallowEqual);
  const saveDisabled = localUrls?.length === 0 || localUrls?.some((url) => !validURL(url));
  const [regUrlsInitialized, setRegUrlsInitialized] = useState(false);
  const [regUrlsInitialValue, setRegUrlsInitialValue] = useState([]);
  const showRemoveRegistries =
    regUrlsInitialized && regUrls.length >= 1 && regUrlsInitialValue.length >= 1;

  useEffect(() => {
    if (!regUrlsInitialized) {
      setRegUrlsInitialized(true);
      setRegUrlsInitialValue(regUrls);
    }
  }, [regUrlsInitialized, regUrls]);

  return (
    <div className="create-flow__overlay-ctas">
      <Button
        data-qa-id="save"
        className="gift-registry__footer__save-btn"
        variant="primary"
        size="large"
        onClick={onSave}
        disabled={saveDisabled}
      >
        Save
      </Button>

      {showRemoveRegistries && (
        <Button
          data-qa-id="remove-wishlist-section"
          className="create-flow__overlay-remove-cta"
          variant="transparent"
          size="large"
          onClick={onRemove}
        >
          Remove wishlist section
        </Button>
      )}
    </div>
  );
};
